module.exports = __webpack_public_path__ + "static/media/woocommerce.56d6b2ba.svg";